module.exports = __webpack_public_path__ + "static/img/14.485edca.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/sp/14.png
// module id = 4COn
// module chunks = 0